import { TypedDocumentNode, gql } from '@apollo/client';

import { OwnedCardRow } from './OwnedCardRow';
import type { LazyAllLastOwnedCardsQuery_anyCard } from './__generated__/fragments.graphql';

const LazyAllLastOwnedCardsQuery_anyCard = gql`
  fragment LazyAllLastOwnedCardsQuery_anyCard on AnyCardInterfaceConnection {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      slug
      inSeasonEligible
      ...OwnedCardRow_anyCard
    }
  }
  ${OwnedCardRow.fragments.anyCard}
` as TypedDocumentNode<LazyAllLastOwnedCardsQuery_anyCard>;

export { LazyAllLastOwnedCardsQuery_anyCard };
